var api = require("!../node_modules/_style-loader@1.1.4@style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../node_modules/_mini-css-extract-plugin@0.8.2@mini-css-extract-plugin/dist/loader.js??ref--5-1!../node_modules/_css-loader@3.5.2@css-loader/dist/cjs.js!../node_modules/_postcss-loader@3.0.0@postcss-loader/src/index.js!./flex.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;